import { Modal, ModalBody, ModalFooter, ROLE, SIZE } from 'baseui/modal'
import React from 'react'
import { useModalStateStore } from '../../utils'
import { LiveViewUI } from './LiveViewUI'
import styles from './LiveViewFullscreenModal.module.css'

export const LiveViewFullscreenModal = () => {
    const { closeModal, isModalOpen } = useModalStateStore()

    return (
        <div>
            <Modal
                onClose={() => closeModal('LiveViewFullscreenModal')}
                closeable
                isOpen={isModalOpen('LiveViewFullscreenModal')}
                animate
                autoFocus
                size={SIZE.auto}
                role={ROLE.dialog}
                overrides={{
                    Close: {
                        style: {
                            top: '32px',
                            fontSize: '50px',
                            marginRight: '7px'
                        }
                    }
                }}
            >
                {/* <ModalHeader>Live View</ModalHeader> */}
                <ModalBody className={styles.modalBody}>
                    <LiveViewUI fullscreen={true} />
                </ModalBody>
            </Modal>
        </div>
    )
}
